import gql from 'graphql-tag'

export const findVersionSuggestionByPPU = gql`
  query find_version_suggestion_by_ppu($ppu: String!) {
    find_version_suggestion_by_ppu(ppu: $ppu)
  }
`
